
import './style.scss';
import { useCallback } from 'react';
import { FormControl, InputLabel, MenuItem, Select, FormHelperText, SelectProps } from '@mui/material';
import { SelectChangeEvent } from "@mui/material";


interface ISelectFieldProps extends SelectProps {
    label?: string;
    name: string;
    data: any[];
    customData?: boolean;
    color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    margin?: 'dense' | 'none';
    disabled?: boolean;
    helperText?: string | undefined;
    required?: boolean;
    variant?: 'filled' | 'outlined' | 'standard';
    value?: any;
    multiple?: boolean;
    className?: string;
    onChange: (event: SelectChangeEvent<any>) => void;
}


const SelectField: React.FC<ISelectFieldProps> = (props) => {
    const constructSelectOptions = useCallback(() => {
        if (props.customData) {
            return props.data;
        }

        return props.data?.map((item: any, index: number) => {
            const value = item.value ?? item;
            const text = item.text ?? item;
            const disabled = item.disabled ?? false;

            return (
                <MenuItem value={value} key={index} disabled={disabled}>
                    {text}
                </MenuItem>
            );
        });
        // eslint-disable-next-line
    }, [props.data]);

    return (
        <FormControl 
            variant={props.variant ?? 'filled'} 
            fullWidth={true} 
            color={props.color ?? 'primary'} 
            margin={props.margin ?? 'normal'} 
            className={`selectfield-default ${props.className}`}
        >
            {
                props.label && <InputLabel>{props.label}</InputLabel>
            }
            
            <Select
                {...props}
                label={props.label ?? undefined}
                name={props.name}
                value={props.value}
                disabled={props.disabled ?? false}
                required={props.required ?? true}
                multiple={props.multiple ?? false}
                onChange={props.onChange}
                
            >
                {
                    constructSelectOptions()
                }
            </Select>

            {
                props.helperText && <FormHelperText> {props.helperText} </FormHelperText>
            }
        </FormControl>
    );
}

export default SelectField;